import StkDepoDonemAutoCompleteDTO from 'src/models/StokEczane/DepoDonemleri/StkDepoDonemAutoCompleteDTO';
import { ApiResponse } from '../core';
import api from '../core/api';
import VwStkDepodonemDTO from 'src/models/StokEczane/DepoDonemleri/VwStkDepodonemDTO';
import { ApiRequest } from 'src/models/api.request';
import { helper } from 'src/utils/helper';

const controllerName = 'DepoDonem';
const controllerName2 = 'VwStkDepodonemDTO/';

export const DepoDonemApi = api.injectEndpoints({
  endpoints: (builder) => ({
    GetDepoForAutoComplete: builder.query<
      StkDepoDonemAutoCompleteDTO[],
      {
        organizasyonId: number;
        searchText: string;
      }
    >({
      query: (request) => ({
        url: controllerName + '/Get',
        method: 'GET',
        params: {
          organizasyonId: request.organizasyonId,
          searchText: request.searchText
        }
      })
    }),
    GetDepoInfoById: builder.query<VwStkDepodonemDTO, { tanimId: number }>({
      query: (req) => ({
        url: controllerName + '/GetByTanimId',
        method: 'GET',
        params: { tanimId: req.tanimId }
      })
    }),

    DepoDonemGetirByYil: builder.query<Array<VwStkDepodonemDTO>,
      {
        yil: number,
        servisCikisYapar?: string,
        hastaCikisYapar?: string,
        depoCikisYapar?: string,
        digerCikisYapar?: string
      }
    >({
      query: (request) => {
        let apiReq: ApiRequest<VwStkDepodonemDTO> = {
          filters: {
            groupOperator: 'and',
            predicates: [
              { fieldName: 'donemYil', operator: '=', value1: request.yil },
              { fieldName: "donemAktif", operator: "=", value1: "E" }
            ]
          },
          sorts: [{ fieldName: "id" }],
        }
        if (request.servisCikisYapar === "E") {
          apiReq.filters.predicates.push({
            fieldName: 'tanimServisCikisYapar',
            operator: '=',
            value1: request.servisCikisYapar
          })
        }
        if (request.hastaCikisYapar === "E") {
          apiReq.filters.predicates.push({
            fieldName: 'tanimHastaCikisYapar',
            operator: '=',
            value1: request.hastaCikisYapar
          })
        }
        if (request.depoCikisYapar === "E") {
          apiReq.filters.predicates.push({
            fieldName: 'tanimDepoCikisYapar',
            operator: '=',
            value1: request.depoCikisYapar
          })
        }
        if (request.digerCikisYapar === "E") {
          apiReq.filters.predicates.push({
            fieldName: 'tanimDepoCikisYapar',
            operator: '=',
            value1: request.digerCikisYapar
          })
        }
        return {
          url: controllerName2 + "find",
          method: "POST",
          body: apiReq
        }
      },
      providesTags:["DepoDonem"]
    })
  })
});

export const {
  useLazyGetDepoForAutoCompleteQuery,
  useGetDepoForAutoCompleteQuery,
  useLazyGetDepoInfoByIdQuery,
  useDepoDonemGetirByYilQuery
} = DepoDonemApi;